import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=3d3907fb&scoped=true&"
import script from "./HelpButton.vue?vue&type=script&lang=ts&"
export * from "./HelpButton.vue?vue&type=script&lang=ts&"
import style0 from "./HelpButton.vue?vue&type=style&index=0&id=3d3907fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3907fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VHover,VIcon,VImg})
